<template>
  <v-snackbar v-model="snack" multi-line bottom>
    {{ $t(`labels.${messageString}`, messageParams) }}
    <template v-slot:action="{ attrs }">
      <v-btn text color="default" v-bind="attrs" @click="snack = false">
        <v-icon small>{{ $vuetify.icons.values.close }}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'

export default {
  name: 'SnackMessage',
  computed: {
    ...mapState(NAMESPACE, ['snackMessage']),
    snack: {
      get() {
        return !!this.snackMessage
      },
      set(v) {
        this.setSnackMessage(null)
      }
    },

    messageString() {
      return this.snackMessage ? this.snackMessage.string : ''
    },
    messageParams() {
      return this.snackMessage ? this.snackMessage.params : {}
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['setSnackMessage'])
  }
}
</script>
